import React, { useState, useEffect } from "react";
import "./componentStyles.css";
import PageHeader from "./PageHeader";
import { Alert, Snackbar } from "@mui/material";

const Pagelayout = ({
  children,
  isGridView,
  setIsGridView,
  handleCreateBtn,
  headerLayout,
  pageName,
  handleBack,
  newData, 
  handleEdit,
  handleSave,
  generatePayslip,
  handleGeneratePayslip,
  gridView,
  filter,
  searchBox,
  createBtn,
  pagination,
  actionBtn,
  saveBtn,
  success,
  saveBtnLoading,
  setSnackbar,
  snackbar,
  isLoading,
  filterOptions,
  categoryOptions,
  postBtn,
  handlePost,
  status,
  returnToDraft,
  computePayslip ,
  handleComputePayslip,
  handleResetToDraft,
  editBtn,
  headerRightExtra,
  deleteBtn,
  handleDelete
}) => {

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: "", severity: "" });
  };

  return (
    <div className="page-layout-wrapper">
      <div className={`page-layout-container `}>
        <PageHeader
          isGridView={isGridView}
          setIsGridView={setIsGridView}
          handleCreateBtn={handleCreateBtn}
          pageName={pageName}
          headerLayout={headerLayout}
          handleBack={handleBack}
          newData={newData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          generatePayslip={generatePayslip}
          handleGeneratePayslip={handleGeneratePayslip}
          gridView={gridView}
          filter={filter}
          searchBox={searchBox}
          createBtn={createBtn}
          pagination={pagination}
          actionBtn={actionBtn}
          saveBtn={saveBtn}
          success={success}
          saveBtnLoading={saveBtnLoading}
          isLoading={isLoading}
          filterOptions={filterOptions}
          categoryOptions={categoryOptions}
          postBtn={postBtn}
          handlePost={handlePost}
          status={status}
          returnToDraft={returnToDraft}
          computePayslip ={computePayslip}
          handleComputePayslip={handleComputePayslip}
          handleResetToDraft={handleResetToDraft}
          editBtn={editBtn}
          headerRightExtra={headerRightExtra}
          deleteBtn={deleteBtn}
          handleDelete={handleDelete}
        />
        <div style={{ padding: "0.5em" }}>{children}</div>
        <Snackbar
        open={snackbar?.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar?.severity}
          sx={{ width: "100%" }}
        >
          {snackbar?.message}
        </Alert>
      </Snackbar>
      </div>
    </div>
  );
};

export default Pagelayout;
